<script setup>
// Палець «подобається» / «не подобається» — та сама іконка, що в коментарях
// (ChatThreadMessage), щоб оцінки скрізь на сайті виглядали однаково.
// down — перевернута для дизлайка
defineProps({
  down: { type: Boolean, default: false },
  size: { type: Number, default: 14 }
})
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    :class="{ 'rotate-180': down }"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66a4.8 4.8 0 0 0-.82-1.1L14 2L7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84A2.34 2.34 0 0 0 9.34 20h8.11c.7 0 1.36-.37 1.72-.97z"
    />
  </svg>
</template>
